import { useState } from 'react'
import type { FC } from 'react'
import { Box, FormControl, MenuItem, Select, TextField } from '@mui/material'
import { useNavigate } from 'react-router'

type SearchByOption = 'user' | 'people' | 'case'
const PersonInstantNav: FC = () => {
  const [query, setQuery] = useState('')
  const [searchBy, setSearchBy] = useState<SearchByOption>('user')
  const navigate = useNavigate()

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value.replace(/\D+/g, '')
    setQuery(query)
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      if (searchBy == 'case') void navigate(`/cases/${query}`)
      else if (searchBy == 'user') void navigate(`/patients/${query}`)
      else void navigate(`/people/${query}`)
      setQuery('')
      setSearchBy('user')
    }
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <FormControl variant="standard" sx={{ m: 1, minWidth: 120, paddingTop: '0.25em' }}>
        <Select
          value={searchBy}
          onChange={e => setSearchBy(e.target.value)}
          style={{ border: 'none' }}
        >
          <MenuItem value="user">Go to user</MenuItem>
          <MenuItem value="people">Go to person</MenuItem>
          <MenuItem value="case">Go to case</MenuItem>
        </Select>
      </FormControl>
      <TextField
        variant="standard"
        fullWidth
        placeholder="ID"
        value={query}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        slotProps={{
          input: {
            sx: {
              '& .MuiInputBase-input': {
                paddingTop: '0.75em',
                paddingBottom: '0.75em',
                width: '5em',
              },
              '&.Mui-focused': {
                backgroundColor: 'common.white',
                outline: theme => `0.1rem solid ${theme.palette.grey[300]}`,
                '&:after': { display: 'none' },
              },
            },
          },
        }}
      />
    </Box>
  )
}

export default PersonInstantNav
